module.exports = __webpack_public_path__ + "img/9788932021874.398a0ad9.jpg";